import { ACCOUNT, RESPONSEDATA } from "app/shared/services/services-model.type";
import { DataTransferCreate } from "../../reducer/types";
import {
  FETCH_TRANSFER_247_CREATE_REQUEST,
  FETCH_TRANSFER_247_CREATE_SUCCESS,
  FETCH_TRANSFER_247_CREATE_FAILURE,
  FETCH_TRANSFER_247_CONFIRM_REQUEST,
  FETCH_TRANSFER_247_CONFIRM_SUCCESS,
  FETCH_TRANSFER_247_CONFIRM_FAILURE,
  FETCH_TRANSFER_247_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_247_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TRANSFER_247_AUTHORIZATION_KEY_FAILURE,
  SET_TRANSFER_247_STORE,
  SET_TRANSFER_247_RESET,
  FETCH_TRANSFER_247_ACCOUNT_DETAIL_REQUEST,
  FETCH_TRANSFER_247_ACCOUNT_DETAIL_SUCCESS,
  FETCH_TRANSFER_247_ACCOUNT_DETAIL_FAILURE,
  FETCH_TRANSFER_247_MAKE_FEE_REQUEST,
  FETCH_TRANSFER_247_MAKE_FEE_SUCCESS,
  FETCH_TRANSFER_247_MAKE_FEE_FAILURE,
} from "./actions.type";
import {
  FetchTransfer247CreateRequest,
  FetchTransfer247CreateSuccess,
  FetchTransfer247CreateFailure,
  FetchTransfer247ConfirmRequest,
  FetchTransfer247ConfirmSuccess,
  FetchTransfer247ConfirmFailure,
  FetchTransfer247AuthorizationRequest,
  FetchTransfer247AuthorizationSuccess,
  FetchTransfer247AuthorizationFailure,
  SetTransfer247Store,
  Transfer247State,
  SetTransfer247Reset,
  FetchTransfer247AccountDetailRequest,
  FetchTransfer247AccountDetailSuccess,
  FetchTransfer247AccountDetailFailure,
  FetchTransfer247MakeFeeFailure,
  FetchTransfer247MakeFeeSuccess,
  FetchTransfer247MakeFeeRequest,
} from "./types";

// 247
export const fetchTransfer247CreateRequest = (payload: DataTransferCreate): FetchTransfer247CreateRequest => ({
  type: FETCH_TRANSFER_247_CREATE_REQUEST,
  payload,
});

export const fetchTransfer247CreateSuccess = (payload?: RESPONSEDATA): FetchTransfer247CreateSuccess => ({
  type: FETCH_TRANSFER_247_CREATE_SUCCESS,
  payload,
});

export const fetchTransfer247CreateFailure = (payload?: string): FetchTransfer247CreateFailure => ({
  type: FETCH_TRANSFER_247_CREATE_FAILURE,
  payload,
});

export const fetchTransfer247ConfirmRequest = (payload?: RESPONSEDATA): FetchTransfer247ConfirmRequest => ({
  type: FETCH_TRANSFER_247_CONFIRM_REQUEST,
  payload,
});

export const fetchTransfer247ConfirmSuccess = (payload?: RESPONSEDATA): FetchTransfer247ConfirmSuccess => ({
  type: FETCH_TRANSFER_247_CONFIRM_SUCCESS,
  payload,
});

export const fetchTransfer247ConfirmFailure = (payload?: string): FetchTransfer247ConfirmFailure => ({
  type: FETCH_TRANSFER_247_CONFIRM_FAILURE,
  payload,
});

export const fetchTransfer247AuthorizationRequest = (payload?: RESPONSEDATA, code?: string): FetchTransfer247AuthorizationRequest => ({
  type: FETCH_TRANSFER_247_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchTransfer247AuthorizationSuccess = (payload?: RESPONSEDATA): FetchTransfer247AuthorizationSuccess => ({
  type: FETCH_TRANSFER_247_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTransfer247AuthorizationFailure = (errorOTP: boolean, payload?: string): FetchTransfer247AuthorizationFailure => ({
  type: FETCH_TRANSFER_247_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});

export const setTransfer247Store = (payload: Transfer247State): SetTransfer247Store => ({
  type: SET_TRANSFER_247_STORE,
  payload,
});

export const setTransfer247Reset = (): SetTransfer247Reset => ({
  type: SET_TRANSFER_247_RESET,
});

// Transfer Detail Account
export const fetchTransfer247AccountDetailRequest = (payload: DataTransferCreate): FetchTransfer247AccountDetailRequest => ({
  type: FETCH_TRANSFER_247_ACCOUNT_DETAIL_REQUEST,
  payload,
});

export const fetchTransfer247AccountDetailSuccess = (payload?: ACCOUNT): FetchTransfer247AccountDetailSuccess => ({
  type: FETCH_TRANSFER_247_ACCOUNT_DETAIL_SUCCESS,
  payload,
});

export const fetchTransfer247AccountDetailFailure = (payload?: string): FetchTransfer247AccountDetailFailure => ({
  type: FETCH_TRANSFER_247_ACCOUNT_DETAIL_FAILURE,
  payload,
});

// Tính phí
export const fetchTransfer247MakeFeeRequest = (payload: DataTransferCreate): FetchTransfer247MakeFeeRequest => ({
  type: FETCH_TRANSFER_247_MAKE_FEE_REQUEST,
  payload,
});

export const fetchTransfer247MakeFeeFailure = (payload?: string): FetchTransfer247MakeFeeFailure => ({
  type: FETCH_TRANSFER_247_MAKE_FEE_FAILURE,
  payload,
});

export const fetchTransfer247MakeFeeSuccess = (payload?: RESPONSEDATA): FetchTransfer247MakeFeeSuccess => ({
  type: FETCH_TRANSFER_247_MAKE_FEE_SUCCESS,
  payload,
});
